// extracted by mini-css-extract-plugin
export default {"button":"ShopNowButton-button-sNo","button__content":"ShopNowButton-button__content-XCk"};